interface DisposedCauseSlice {
    disposedCause: {
        reasons: string[];
    };
    setDisposedCause: (reasons: string[]) => void;
    resetDisposedCause: () => void;
}

const createDisposedCauseSlice = (set: any) => ({
    disposedCause: {
        reasons: [],
    },
    setDisposedCause: (reasons: string[]) =>
        set({
            disposedCause: {
                reasons,
            },
        }),
    resetDisposedCause: () =>
        set({
            disposedCause: {
                reasons: [],
            },
        }),
});

export { createDisposedCauseSlice };
export type { DisposedCauseSlice };
